import React from 'react'
import './style.css'
import ContactCompass from './ContactCompass'

const CompassPrivacyPolicy = () => {
    return (
        <>
            <div className="compass-policy-body">
                <main className="compass-page">
                    <header className="compass-header">
                        <div className="compass-brand">
                        </div>
                        <h1 className="compass-title">Compass Digital </h1>
                        <div className="compass-brand">
                            <span className="compass-brand-text">Privacy Policy</span>
                        </div>
                        <p className="compass-last-updated">Last updated: 10 Sep 2025</p>
                    </header>
                    <section className="compass-card">
                        <div className="compass-content">
                            <h2 className="compass-section-title">1. Information We Collect</h2>
                            <p className="compass-paragraph">Our Compass Digital app collects the following information:</p>
                            <ul className="compass-bullets">
                                <li>Location data (GPS coordinates) to provide compass functionality</li>
                                <li>Device information for ad personalization</li>
                                <li>App usage analytics to improve user experience</li>
                                <li>Analytics data via Firebase Analytics (e.g., app interactions, approximate location, device identifiers such as App Instance ID, and aggregated usage statistics)</li>
                            </ul>

                            <h2 className="compass-section-title">2. How We Use Your Information</h2>
                            <p className="compass-paragraph">We use the collected information to:</p>
                            <ul className="compass-bullets">
                                <li>Provide accurate compass readings and location services</li>
                                <li>Display relevant advertisements</li>
                                <li>Improve app performance and user experience</li>
                                <li>Analyze app usage patterns</li>
                            </ul>

                            <h2 className="compass-section-title">3. Location Data</h2>
                            <p className="compass-paragraph">Our app requires location permissions to function properly. Location data is used solely for:</p>
                            <ul className="compass-bullets">
                                <li>Calculating compass direction and magnetic declination</li>
                                <li>Displaying latitude, longitude, and altitude</li>
                                <li>Providing accurate compass readings based on your geographic location</li>
                            </ul>
                            <p className="compass-paragraph">Location data is processed locally on your device and is not stored on our servers.</p>

                            <h2 className="compass-section-title">4. Advertising</h2>
                            <p className="compass-paragraph">Our app displays advertisements provided by Google AdMob. These ads may be personalized based on:</p>
                            <ul className="compass-bullets">
                                <li>Your device information</li>
                                <li>App usage patterns</li>
                                <li>General location (not precise coordinates)</li>
                            </ul>
                            <p className="compass-paragraph">You can opt out of personalized ads through your device settings.</p>

                            <h2 className="compass-section-title">5. Third-Party Services</h2>
                            <p className="compass-paragraph">Our app uses the following third-party services:</p>
                            <ul className="compass-links">
                                <li><a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">Firebase - Privacy and Security</a></li>
                                <li><a href="https://support.google.com/firebase/answer/6318039" target="_blank" rel="noopener noreferrer">Google Analytics for Firebase - Data Collection</a></li>
                                <li><a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google AdMob - Privacy Policy</a></li>
                                <li><a href="https://support.google.com/admob/answer/6128543" target="_blank" rel="noopener noreferrer">Google AdMob - Ad Personalization</a></li>
                                <li><a href="https://unity.com/legal/privacy-policy" target="_blank" rel="noopener noreferrer">Unity Ads - Privacy Policy</a></li>
                            </ul>

                            <h2 className="compass-section-title">6. Data Security</h2>
                            <p className="compass-paragraph">We implement appropriate security measures to protect your information. However, no method of transmission over the internet is 100% secure.</p>

                            <h2 className="compass-section-title">7. Children's Privacy</h2>
                            <p className="compass-paragraph">Our app does not knowingly collect personal information from children under 13. If you are a parent and believe your child has provided us with personal information, please contact us.</p>

                            <h2 className="compass-section-title">8. Changes to Privacy Policy</h2>
                            <p className="compass-paragraph">We may update this privacy policy from time to time. We will notify you of any changes by posting the new privacy policy in the app.</p>

                            <h2 className="compass-section-title">9. Contact Us</h2>
                            <p className="compass-paragraph">If you have any questions about this privacy policy, please contact us at:</p>
                                <ContactCompass/>
                            <h2 className="compass-section-title">10. Your Rights</h2>
                            <p className="compass-paragraph">You have the right to:</p>
                            <ul className="compass-bullets">
                                <li>Request access to your personal data</li>
                                <li>Request correction of your personal data</li>
                                <li>Request deletion of your personal data</li>
                                <li>Opt out of personalized advertising</li>
                            </ul>

                            <div className="compass-footer-note" role="note">
                                By using this app, you agree to this privacy policy.
                            </div>
                        </div>
                    </section>
                </main>
            </div>
        </>
    )
}

export default CompassPrivacyPolicy